import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {StoreModule} from '@ngrx/store';
import {CATEGORY_FEATURE_KEY,featuresReducers} from '@app/marketplace/app.state';
import {EffectsModule} from '@ngrx/effects';
import {SharedModule} from '@app/marketplace/shared/shared.module';
import {NgbModule, NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';
import {ReactiveFormsModule} from '@angular/forms';
import {CategoryListComponent} from '@app/marketplace/categories/category-list/category-list.component';
import {CategoriesRoutingModule} from '@app/marketplace/categories/categories-routing.module';
import {CategoriesEffects} from '@app/marketplace/categories/state/category/categories-effects';
import {NgxSkeletonLoaderModule} from 'ngx-skeleton-loader';

@NgModule({
  declarations: [
    CategoryListComponent
  ],
  imports: [
    CommonModule,
    CategoriesRoutingModule,
    StoreModule.forFeature(CATEGORY_FEATURE_KEY, featuresReducers),
    EffectsModule.forFeature([CategoriesEffects]),
    SharedModule,
    NgbModule,
    ReactiveFormsModule,
    NgxSkeletonLoaderModule.forRoot({ animation: 'pulse'})
  ]
})
export class CategoriesModule { }
